import { Box } from '@mui/material'

import { useSettingsEditing } from '../../hooks/useSettingsEditing'

import { LanguageAndFormatsForm } from './LanguageAndFormatsForm'
import { LanguageAndFormatsView } from './LanguageAndFormatsView'

export function LanguageAndFormats() {
  const { editing, onEdit, onDiscard } = useSettingsEditing('rm-account', 'reset')

  return (
    <Box display="flex" width="100%" height="100%" data-testid="language-and-formats-root">
      {!editing && <LanguageAndFormatsView onEdit={onEdit} />}
      {editing && <LanguageAndFormatsForm onDiscard={onDiscard} />}
    </Box>
  )
}
